// 각성 중 BGM 덕킹 곡선(AV-SPEC: -8dB, 900ms). 순수 함수.
// 각성이 시작되면 120ms에 걸쳐 -8dB까지 내리고, 각성이 끝나면 900ms에 걸쳐 원래대로 돌린다.

import { volumeToGain } from './settings';
export const DUCK_DB = -8;
export const DUCK_ATTACK = 0.12;
export const DUCK_RELEASE = 0.9;

/**
 * sinceStart: 각성 시작 후 초(시작 전이면 음수 또는 Infinity로 무시).
 * sinceEnd: 각성 종료 후 초. 아직 각성 중이면 음수.
 * 반환: BGM 감쇠(dB, 0 또는 음수).
 */
export function duckDb(sinceStart: number, sinceEnd: number): number {
  if (!(sinceStart >= 0) || !Number.isFinite(sinceStart)) return 0;
  // +0: -0을 0으로 맞춘다
  const attackAt = (t: number): number => (t >= DUCK_ATTACK ? DUCK_DB : (DUCK_DB * t) / DUCK_ATTACK + 0);
  if (sinceEnd < 0) return attackAt(sinceStart);
  // 종료 시점에 도달해 있던 감쇠에서 출발해 900ms에 0으로
  const from = attackAt(Math.max(0, sinceStart - sinceEnd));
  if (sinceEnd >= DUCK_RELEASE) return 0;
  return from * (1 - sinceEnd / DUCK_RELEASE) + 0;
}

export function dbToGain(db: number): number {
  return Math.pow(10, db / 20);
}

// 2026-11-03 큰 타격 덕킹: 보스 포효·마무리 일격·착지처럼 큰 효과음이 나면 BGM을 잠깐 눌러 소리가 앞으로 나오게 한다.
// 30ms에 IMPACT_DUCK_DB까지 → 120ms 유지 → 500ms에 걸쳐 복귀. 각성 덕킹과 겹치면 더 깊은 쪽을 쓴다(index.ts).
export const IMPACT_DUCK_DB = -4;
export const IMPACT_ATTACK = 0.03;
export const IMPACT_HOLD = 0.12;
export const IMPACT_RELEASE = 0.5;

/** since: 큰 타격 후 초(음수·Infinity면 0). 반환 dB(0 또는 음수) */
export function impactDuckDb(since: number): number {
  if (!(since >= 0) || !Number.isFinite(since)) return 0;
  if (since < IMPACT_ATTACK) return (IMPACT_DUCK_DB * since) / IMPACT_ATTACK + 0;
  if (since < IMPACT_ATTACK + IMPACT_HOLD) return IMPACT_DUCK_DB;
  const r = since - IMPACT_ATTACK - IMPACT_HOLD;
  return r >= IMPACT_RELEASE ? 0 : IMPACT_DUCK_DB * (1 - r / IMPACT_RELEASE) + 0;
}

/**
 * 큰 소리가 BGM을 눌러야 하는가: 큰 묶음이고 음량 -3dB 이상이며, 마스터·효과음 볼륨이 0이 아닐 때만.
 * 효과음이 안 들리는데 BGM만 눌리면 안 된다(볼륨 0·음소거).
 */
export function impactDucks(bigGroup: boolean, totalDb: number, vols: { master: number; sfx: number }): boolean {
  return bigGroup && totalDb >= -3 && volumeToGain(vols.master) > 0 && volumeToGain(vols.sfx) > 0;
}
